export default __webpack_public_path__ + "static/media/MobIconImg.888e5c2a.svg";